import { cn } from "@heroui/react";

import { Option } from "@/types/dataSchema";

import {
  filterOptionsByConditions,
  getLayoutConfig,
} from "../utils/optionUtils";

import { OptionButton } from "./OptionButton";

interface OptionGridProps {
  options: Option[];
  currentAnswersFromContext: Record<string, any>;
  selectedOptions: string[];
  editValues: { [key: string]: string };
  isRevealed: boolean;
  isMultiSelect: boolean;
  onSelectOption: (optionValue: string, editable?: boolean) => void;
}

export const OptionGrid: React.FC<OptionGridProps> = ({
  options,
  currentAnswersFromContext,
  selectedOptions,
  editValues,
  isRevealed,
  isMultiSelect,
  onSelectOption,
}) => {
  const filteredOptions = filterOptionsByConditions(
    options,
    currentAnswersFromContext,
  );

  const { size, buttonSize, gridCols } = getLayoutConfig(
    filteredOptions.length,
  );

  return (
    <div className={cn("grid", "gap-5", gridCols)}>
      {filteredOptions.map((option, index) => {
        const isSelected = selectedOptions.includes(option.value);

        return (
          <OptionButton
            key={option.value}
            buttonSize={buttonSize}
            editValues={editValues}
            index={index}
            isMultiSelect={isMultiSelect}
            isRevealed={isRevealed}
            isSelected={isSelected}
            option={option}
            size={size}
            onSelectOption={onSelectOption}
          />
        );
      })}
    </div>
  );
};
